module.exports = __webpack_public_path__ + "static/media/illustration.9d0b7af0.svg";